import { createRouter, createWebHistory } from 'vue-router';

import { showMobileAppBanner } from '~/composables';
import { Devices } from '~/plugins';

import { routes } from './routes';

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes
});

router.afterEach((_to, _from, failure) => {
	if (!failure) {
		if (Devices().isIOS || Devices().isAndroid) {
			showMobileAppBanner();
		}
	}
});

export { router };
